import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ActivityDto, EntityDto, UserServiceClient} from '@sharedrest/identity.restservice';
import {UserService} from '@sharedcommon/services/user.service';
import {ResultSettingsService} from '@usercommon/service/result-settings.service';
import { OperatingModeUtil } from '@sharedcommon/util/operating-mode.util';
import { ActivityUtil } from '@sharedcommon/util/activity.util';

@Component({
  templateUrl: './entity-choice.page.html'
})
export class NeqEntityChoicePage implements OnInit {

  hasEntities: boolean;
  hasMultipleActivities: boolean;
  hasMultipleEntities: boolean;

  activities: ActivityDto[];
  entities: EntityDto[];
  operatingModes: string[];

  selectedOperatingMode: string;

  intializationDone: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly user: UserService,
    private readonly userService: UserServiceClient,
    private readonly resultSettingsService: ResultSettingsService
  ) {
  }

  ngOnInit() {
    const filteredActivityCodes = this.getFilteredActivitiesCode();
    this.hasMultipleActivities = filteredActivityCodes.length > 1;
    const user = this.user.getUser();
    this.hasMultipleEntities = user?.entities && user.entities.length > 1;
    this.hasEntities = user?.entities && user.entities.length > 0;
    if (this.canAccessAdminSite() || this.hasMultipleActivities) {
      /* Set at true to show the selection in the page */
      this.intializationDone = true;
      this.userService.getCurrentUserActivities().subscribe(activities => this.activities = this.filterActivities(activities));
    } else if (this.hasEntities && filteredActivityCodes.length == 1) {
      /* If on activity is present then auto select it */
      this.onActivityCodeSelection(filteredActivityCodes[0]);
    } else {
      /* Set at true to show the selection in the page */
      this.intializationDone = true;
    }
  }

  getFilteredActivitiesCode(): string[] {
    const user = this.user.getUser();
    if (!user?.activities) {
      return[];
    }

    return user.activities.filter(activity => ActivityUtil.isAllowedActivityCode(activity));
  }

  filterActivities(activities: ActivityDto[]): ActivityDto[] {
    return activities.filter(activity => ActivityUtil.isAllowedActivityCode(activity.code))
  }

  onEntityFetch(allEntities: EntityDto[]): void {
    this.operatingModes = [];
    this.entities = [];
    allEntities.forEach((entity) => {
      if (!entity.operatingModes) {
        return;
      }
      let isValidEntity: boolean = false ;
      OperatingModeUtil.returnAllowedOperatingModesOfEntity(entity).forEach(opModeOfEntity => {
        /* If in the loop that means that we have a valid entity because it has a valid operating modes */
        isValidEntity = true;
        if (!this.operatingModes.includes(opModeOfEntity)) {
          /* Add if in the operating mode list if not already inserted */
          this.operatingModes.push(opModeOfEntity);
        }
      });
      if (isValidEntity) {
        this.entities.push(entity);
      }
    });

    if (this.operatingModes.length === 1) {
      /* If one operating mode then only auto select it */
      this.onOperatingModeSelection(this.operatingModes[0]);
    } else {
      /* Set at true to show the selection in the page */
      this.intializationDone = true;
    }
  }

  onOperatingModeSelection(operatingMode: string): void {
    this.user.setOperatingMode(operatingMode);
    this.selectedOperatingMode = operatingMode;
    /* Filter the entities which has the selected operating mode only */
    this.entities = this.entities.filter((entity) => {
      return OperatingModeUtil.isEntityHasOperatingMode(entity, operatingMode);
    });
    if (this.entities.length === 1) {
      /* If one entity only then auto select it */
      this.onEntitySelection(this.entities[0]);
    } else {
      /* Set at true to show the selection in the page */
      this.intializationDone = true;
    }
  }

  returnOperatingModeTranslationKey(operatingMode: string): string {
    return OperatingModeUtil.returnTranslationKey(operatingMode);
  }

  onEntitySelection(entityDto: EntityDto): void {
    this.user.setEntityDto(entityDto);
    this.resultSettingsService.clear();
    this.redirectToApp();
  }

  canAccessAdminSite(): boolean {
    return this.user.isAdmin();
  }

  onActivityClicked(activity: ActivityDto) {
    if (!activity) {
      return;
    }
    this.onActivityCodeSelection(activity.code);
  }

  onActivityCodeSelection(activityCode: string): void {
    this.user.setActivity(activityCode);
    this.activities = null;
    this.userService.getCurrentUserEntities({activityCode: activityCode}).subscribe(entities => {
      this.onEntityFetch(entities);
    });
  }

  onEntityClicked(entity: EntityDto) {
    if (!entity) {
      return;
    }
    this.onEntitySelection(entity);
  }

  logout() {
    this.router.navigate(['logout']);
  }

  goToAdmin() {
    if (this.user.isAdmin()) {
      this.user.setEntityDto(null);
      this.router.navigate(['/admin-site']);
    }
  }

  private redirectToApp() {
    this.router.navigate(['/app']);
  }

}
